import { jsx as _jsx } from "react/jsx-runtime";
// Spinner — индикатор ожидания (загрузка/прогресс). Чистый CSS-анимированный круг на токенах.
// Анимация задаётся через keyframes, инжектируемые в DOM один раз (см. ensureKeyframes).
import { useEffect } from 'react';
const KEYFRAMES_ID = 'tc-ds-spin-keyframes';
/** Однократно вставляет @keyframes spin в документ (идемпотентно). */
function ensureKeyframes() {
    if (typeof document === 'undefined')
        return;
    if (document.getElementById(KEYFRAMES_ID))
        return;
    const style = document.createElement('style');
    style.id = KEYFRAMES_ID;
    style.textContent =
        '@keyframes tc-ds-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
}
export function Spinner({ size = 20, thickness = 2, label = 'Загрузка', style }) {
    useEffect(ensureKeyframes, []);
    const base = {
        display: 'inline-block',
        width: `${size}px`,
        height: `${size}px`,
        border: `${thickness}px solid var(--color-divider)`,
        borderTopColor: 'var(--color-accent)',
        borderRadius: '50%',
        animation: `tc-ds-spin var(--motion-slow) linear infinite`,
        ...style,
    };
    return _jsx("span", { role: "status", "aria-label": label, "data-spinner": "", style: base });
}
//# sourceMappingURL=Spinner.js.map